import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import DataManagement from "../../components/table/DataManagement.jsx";
import { Link } from "react-router-dom";

import { useInvalidaciones } from "../../hooks_cache/useInvalidaciones.js";
import Swal from "sweetalert2";

const columns = [
  { accessorKey: "id", header: "ID" },
  { accessorKey: "identificacion.codigoGeneracion", header: "Codigo Generacion de Invalidacion" },
  { accessorKey: "identificacion.fecAnula", header: "Fecha Anulacion" },
  {
    accessorKey: "documento.codigoGeneracion",
    header: "Documento invalidado",
    cell: ({ row }) => {
      const {
        id_comprobante,
        documento: { codigoGeneracion },
      } = row.original;
      return (
        <Link to={`/venta/comprobante/${id_comprobante}`} className="fw-bold text-nowrap">
          {codigoGeneracion}
        </Link>
      );
    },
  },
  { accessorKey: "documento.numeroControl", header: "Numero de control" },
  { accessorKey: "documento.nombre", header: "Nombre / Razon social" },
  { accessorKey: "motivo.motivoAnulacion", header: "Motivo" },
];

function InvalidacionesEmitidas() {
  const { data: dataInvalidaciones, refetch, isFetching } = useInvalidaciones();
  const [dataInvalidacionesFiltered, setDataInvalidacionesFiltered] = useState([]);

  useEffect(() => {
    if (isFetching) {
      Swal.fire({
        title: "Cargando invalidaciones...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    } else {
      Swal.close();
    }
  }, [isFetching]);

  useEffect(() => {
    if (dataInvalidaciones?.length > 0) {
      const filteredData = dataInvalidaciones.map((item) => {
        const { json_evento, id_comprobante } = item;
        const invObj = JSON.parse(json_evento);
        console.log(item);

        return {
          id: item.id,
          id_comprobante: id_comprobante,
          ...invObj,
        };
      });

      setDataInvalidacionesFiltered(filteredData);
    }
  }, [dataInvalidaciones]);

  return (
    <DataManagement
      columns={columns}
      data={dataInvalidacionesFiltered}
      title="Eventos de invalidacion"
      actions={[
        <button onClick={refetch} className="btn btn-theme btn-sm d-flex pe-3 rounded-3">
          <Icon className="iconify fs-18px me-2 ms-n1" icon="solar:refresh-bold-duotone" />
          Refrescar tabla
        </button>,
      ]}
    />
  );
}

export default InvalidacionesEmitidas;
